import { Select } from "antd"
import React from "react"

const SelectLeader = ({ value, onChange,disabled, style={ height: "36px"} }) => {
  return (
    <Select
      placeholder="Chọn loại đại lý"
      title="Chọn loại đại lý"
      allowClear
      value={value}
      onChange={onChange}
      disabled = {disabled}
      style={style}
    >
      <Select.Option value={0}>Tổng đại lý</Select.Option>
      <Select.Option value={1}>Đại lý cấp 1</Select.Option>
      <Select.Option value={2}>Đại lý cấp 2</Select.Option>
      <Select.Option value={3}>Đại lý cấp 3</Select.Option>
    </Select>
  )
}

export default SelectLeader
